import { render, staticRenderFns } from "./jobList.vue?vue&type=template&id=fbfa7a16&scoped=true&"
import script from "./jobList.vue?vue&type=script&lang=js&"
export * from "./jobList.vue?vue&type=script&lang=js&"
import style0 from "./jobList.vue?vue&type=style&index=0&id=fbfa7a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfa7a16",
  null
  
)

export default component.exports